var ReactGA = require('react-ga');
ReactGA.initialize(getGAKey(), { debug: false });

var Tracker = {
    trackPageView: function(pageName) {
        if (!isDev()) {
            ReactGA.pageview(pageName);
        }
    },
    trackEvent: function(category, action, label, value) {
        if (!isDev()) {
            ReactGA.event({
                category: category,
                action: action,
                label: label,
                value: value
            });
        }
    },
    setCustomDimension: function(dimension, value) {
        if (!isDev()) {
            ReactGA.set({[dimension]: value});
        }
    }
};

function getGAKey() {
    // if (document.domain.match(/dev|localhost/)) {
    //     return 'UA-89646306-1';
    // } else if (document.domain.match(/staging/)) {
    //     return 'UA-89776220-2';
    // }
    return 'UA-93123640-2';
}

function isDev() {
    return document.domain !== "locator.infusioncenter.org";
}

export default Tracker;



// WEBPACK FOOTER //
// ./src/components/common/Tracker.js